import React from 'react';
import { Row, Col } from 'react-bootstrap';

const InfoCardsSection = () => {
  const cards = [
    {
      title: "Якщо скоро в школу?",
      content: "Дізнатись яка саме школа закріплена за місцем реєстрації дитини можна на освітній карті Києва",
      link: "Карта шкіл",
      href: "https://gis.kyivcity.gov.ua/schools/"
    }
  ];

  return (
    <section className="my-5 info-cards-section">
      
        {cards.map((card, index) => (
            <Row>
                <Col md={12} lg={12} key={index} className="mb-12">
                    <div className="info-card h-100">
                    <div className="card-content">
                        <h5>{card.title}</h5>
                        <p>{card.content}</p>
                    </div>
                    <a href={card.href} className="info-card-link">{card.link}</a>
                    </div>
                </Col>
          </Row>
        ))}
    </section>
  );
};

export default InfoCardsSection;